// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1R7kZ","menuItem":"styles__menuItem___ptuep","text":"styles__text___G-1ev","count":"styles__count___3IPsT"};